import { inject, provideAppInitializer } from "@angular/core";
import { AuthService } from "./api/services/auth.service";
import { Router } from "@angular/router";
import { catchError, map, Observable, tap } from "rxjs";
import { ProfileActions, ProfileStoreState } from "./core/store/profile";
import { Store } from "@ngrx/store";
import { VariablesService } from "./partials/services/variables.service";
import { TokenRefreshService } from "./api/services/token-refresh.service";
import { TwoFactorService } from "./api/services/two-factor.service";
import { persistPostLoginRedirectUrl } from "./partials/helpers/post-login-redirect";

export const appConfigInit = provideAppInitializer(() => {
    const initializerFn = ((router: Router, authService: AuthService, variablesService: VariablesService, tokenRefreshService: TokenRefreshService, twoFactorService: TwoFactorService, profileStore: Store<{
        profile: ProfileStoreState
    }>) => {
        return (): Observable<boolean> | Promise<boolean> => {
            const token: string | null = localStorage.getItem('token');
            const userInfo: string | null = localStorage.getItem('userInfo');

            if (!token) {
                persistPostLoginRedirectUrl();
                localStorage.removeItem('token');
                localStorage.removeItem('tokenExpiresAt');
                localStorage.removeItem('userInfo');
                return router.navigate(['login']);
            }

            return authService.checkValidSession().pipe(
                tap(() => {
                    if (userInfo && JSON.parse(userInfo)) {
                        const parsedUserInfo = JSON.parse(userInfo);
                        variablesService.role.set(parsedUserInfo.role);
                        // variablesService.role.set('SALES');
                        profileStore.dispatch(ProfileActions.setProfileData({ payload: parsedUserInfo }));
                    }
                    tokenRefreshService.start();
                    // Cache the 2FA enrollment flag so critical actions can prompt for a code up-front.
                    twoFactorService.loadStatus().subscribe({ error: () => {} });
                }),
                map(Boolean),
                catchError(() => {
                    tokenRefreshService.stop();
                    persistPostLoginRedirectUrl();
                    localStorage.removeItem('token');
                    localStorage.removeItem('tokenExpiresAt');
                    localStorage.removeItem('userInfo');
                    return router.navigate(['login']);
                }));
        }
    })(inject(Router), inject(AuthService), inject(VariablesService), inject(TokenRefreshService), inject(TwoFactorService), inject(Store));
    return initializerFn();
});
